import React from 'react';
import { formatFreeTrialOffer, formatGuestPlanChoices } from '../utils/guestUpgradeOffer';

const GuestUpgradeModal = ({
  isOpen,
  onClose,
  onUpgrade,
  freeTrialDeals,
  planNames,
  loading = false,
}) => {
  if (!isOpen) {
    return null;
  }

  const planChoices = formatGuestPlanChoices(planNames);
  const trialOffer = formatFreeTrialOffer(freeTrialDeals);

  return (
    <div className="guest-upgrade-modal-backdrop" onClick={onClose}>
      <div
        className="guest-upgrade-modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="guest-upgrade-modal-title"
      >
        <div className="guest-upgrade-modal-header">
          <h2 id="guest-upgrade-modal-title">Upgrade to create documents</h2>
          <button
            type="button"
            className="guest-upgrade-close-button"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className="guest-upgrade-modal-body">
          <p>
            Only subscribing KeyFlo users can create forms for new transactions.
          </p>
          <p>
            You can upgrade your account to {planChoices} by adding a credit card on your profile.
          </p>
          <p className="guest-upgrade-offer">
            {loading ? 'Loading offer…' : (
              <>First-time subscribers get <strong>{trialOffer}</strong> to start.</>
            )}
          </p>
        </div>
        <div className="guest-upgrade-modal-actions">
          <button type="button" className="guest-upgrade-secondary-button" onClick={onClose}>
            Not now
          </button>
          <button type="button" className="guest-upgrade-primary-button" onClick={onUpgrade}>
            Upgrade &amp; add card
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuestUpgradeModal;
